import { call, put, select } from 'redux-saga/effects';
import isEqual from 'lodash.isequal';
import { selectDeviceType } from 'features/application/applicationSlice';
import {
  selectPinnedPanels,
  remotePinnedPanelsReceived,
  pinnedPanelsReceived,
} from 'features/side-panels/sidePanelsSlice';
import { SidePanelType } from 'features/side-panels/types';
import { filterAccessiblePanels } from './filterAccessiblePanels';
import { isMobileViewport } from './isMobileViewport';

export function* applyRemotePinnedPanelsSaga(panels: SidePanelType[]) {
  yield put(remotePinnedPanelsReceived({ panels }));

  if (!panels.length) {
    yield put(pinnedPanelsReceived({ panels: [] }));
    return;
  }

  const deviceType: string = yield select(selectDeviceType);
  const isMobile: boolean = yield call(isMobileViewport, deviceType);

  if (isMobile) {
    return;
  }

  const filtered: SidePanelType[] = yield call(filterAccessiblePanels, panels);
  const current: SidePanelType[] = yield select(selectPinnedPanels);

  if (isEqual(filtered, current)) {
    return;
  }

  yield put(pinnedPanelsReceived({ panels: filtered }));
}
